module.exports = __webpack_public_path__ + "static/media/bg.8c279e19.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg.gif
// module id = 12
// module chunks = 0